
// @ts-nocheck
import locale__var_www_frontend_locale_locales_lt_json from "../locale/locales/lt.json";
import locale__var_www_frontend_locale_locales_en_json from "../locale/locales/en.json";


export const localeCodes =  [
  "lt",
  "en"
]

export const localeLoaders = {
  "lt": [{ key: "../locale/locales/lt.json", load: () => Promise.resolve(locale__var_www_frontend_locale_locales_lt_json), cache: true }],
  "en": [{ key: "../locale/locales/en.json", load: () => Promise.resolve(locale__var_www_frontend_locale_locales_en_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "lt",
      "iso": "lt-LT",
      "files": [
        "locale/locales/lt.json"
      ]
    },
    {
      "code": "en",
      "iso": "en-US",
      "files": [
        "locale/locales/en.json"
      ]
    }
  ],
  "defaultLocale": "lt",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "locale/locales",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "config",
  "pages": {
    "maintenance": {
      "en": "/maintenance",
      "lt": "/maintenance"
    },
    "login": {
      "en": "/login",
      "lt": "/prisijungimas"
    },
    "termsAndRules/index": {
      "en": "/terms-and-rules",
      "lt": "/taisykles-ir-nuostatos"
    },
    "registerInstructions": {
      "en": "/register-instructions",
      "lt": "/registracijos-instrukcija"
    },
    "forLawyer": {
      "en": "/for-lawyer",
      "lt": "/teisininkui"
    },
    "lawyers/[specialty]": {
      "en": "/lawyers/[specialty]",
      "lt": "/teisininkai/[specialty]"
    },
    "lawyer/[slug]": {
      "en": "/lawyer/[slug]",
      "lt": "/teisininkas/[slug]"
    },
    "firm/[slug]": {
      "en": "/firm/[slug]",
      "lt": "/kontora/[slug]"
    },
    "appointment/[firmLawyerId]": {
      "en": "/appointment/[firmLawyerId]",
      "lt": "/rezervacija/[firmLawyerId]"
    },
    "lawyerCalendar/[firmLawyerId]": {
      "en": "/lawyer-calendar/[firmLawyerId]",
      "lt": "/teisininko-kalendorius/[firmLawyerId]"
    },
    "account/index": {
      "en": "/account",
      "lt": "/paskyra"
    },
    "account/index/change-password": {
      "en": "/account/change-password",
      "lt": "/paskyra/slaptazodzio-keitimas"
    },
    "account/index/firm": {
      "en": "/account/firm",
      "lt": "/paskyra/kontora"
    },
    "account/index/danger-zone": {
      "en": "/account/danger-zone",
      "lt": "/paskyra/pavojinga-zona"
    },
    "account/index/account-management": {
      "en": "/account/account-management",
      "lt": "/paskyra/paskyros-valdymas"
    },
    "account/index/profile": {
      "en": "/account/profile",
      "lt": "/paskyra/profilis"
    },
    "account/index/workHours": {
      "en": "/account/work-hours",
      "lt": "/paskyra/darbo-laikas"
    },
    "action/meeting/[id]": {
      "en": "/action/meeting/[id]",
      "lt": "/veiksmas/susitikimas/[id]"
    },
    "action/payment": {
      "en": "/action/payment",
      "lt": "/veiksmas/mokejimas"
    },
    "user-activation/[id]": {
      "en": "/user-activation/[id]",
      "lt": "/vartotojo-aktyvavimas/[id]"
    },
    "proposal/index": {
      "en": "/proposal",
      "lt": "/pasiulymas"
    },
    "services/index": {
      "en": "/services",
      "lt": "/paslaugos"
    },
    "services/[id]": {
      "en": "/services/[id]",
      "lt": "/paslaugos/[id]"
    },
    "payments/index": {
      "en": "/payments",
      "lt": "/mokejimas"
    },
    "leaveReview/[id]": {
      "en": "/leave-review/[lawyerId]",
      "lt": "/palikti-atsiliepima/[lawyerId]"
    }
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "lt",
    "iso": "lt-LT",
    "files": [
      {
        "path": "locale/locales/lt.json"
      }
    ]
  },
  {
    "code": "en",
    "iso": "en-US",
    "files": [
      {
        "path": "locale/locales/en.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
